import EditProperty from "../../Common/editProperty.js";
import ClientEditAddress from "../rca-offer/clientEditAddress.vue";

export default {
    name: "EditProperty",
    extends: EditProperty,
    components: { ClientEditAddress },
    data: () => {
        return {
            address: {}
        };
    },

    mounted: () => {
        this.address = this.$refs.editPropAddress.$v;
        this.$watch(
            "address",
            () => {
                if (
                    this.$v.$invalid &&
                    !this.$refs.editPropAddress.$v.$invalid
                ) {
                    this.$emit("can-continue", { value: true });
                } else {
                    this.$emit("can-continue", { value: false });
                }
            },
            { deep: true }
        );
    },

    methods: {
        markAsTouched: function(val) {
            const field = this.getDescendantProp(this.$v, val);
            field && field.$touch();
        },
        chkState: function(val) {
            const field = this.getDescendantProp(this.$v, val);
            return field && field.$dirty ? !field.$error : null;
        }
    }
};
